<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Work Schedules
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div>
            <el-dropdown placement="bottom-start" @command="handleCommand">
              <el-button style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('settings_payXoft_timeKeeping_schedules_addSchedule')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="normalDay" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_normal')}}</el-dropdown-item>
                <el-dropdown-item command="flexy" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_flexi')}}</el-dropdown-item>
                <el-dropdown-item command="rotated" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_rotations')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
              <el-tab-pane :label="$t('settings_payXoft_timeKeeping_normal')" name="schedules">

              </el-tab-pane>

              <el-tab-pane :label="$t('settings_payXoft_timeKeeping_flexi')" name="flexi">
                Current Service Under Development
              </el-tab-pane>

              <el-tab-pane :label="$t('settings_payXoft_timeKeeping_rotations')" name="rotations">
                Current Service Under Development
              </el-tab-pane>
            </el-tabs>
            <add-schedule-modal ref="addScheduleModalComponent" @loadList="loadList"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddScheduleModal from "@/components/settings/humanCapitalManagement/AddScheduleModal";
export default {
  name: "WorkSchedules",
  components: {AddScheduleModal},
  data() {
    return {
      value: 'schedules'
    }
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'normalDay':
          this.$refs.addScheduleModalComponent.open();
          break;
      }
    },
    handleClick(tab){

    },
    openModalAdd(){

    },
    loadList(){
      console.log('load list')
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
